import React from 'react';
import { Navbar, Footer, AnnouncementBar } from "../components";

const Terms = () => (
  <>
    <AnnouncementBar />
    <Navbar />
    <div className="container my-4">
      <h2>Terms & Conditions</h2>
      <ul>
        <li>Prices are inclusive of applicable taxes unless stated otherwise.</li>
        <li>Orders may be cancelled if products are out of stock or suspected of fraudulent activity.</li>
        <li>By placing an order, you agree to our policies and delivery timelines.</li>
      </ul>
    </div>
    <Footer />
  </>
);

export default Terms;
